<template>
  <HeaderPopup v-bind:onCloseClick="onCloseClick">
    <div class="demo-block">
      <div class="icon">
        <lottie-player
          src="/static/demo-popup.json"
          background="transparent"
          speed="1"
          style="width: 76px; height: 76px; margin-top: 40px"
          autoplay
          loop
        ></lottie-player>
      </div>
      <div class="text">
        This is the <span class="highlight">DEMO version</span> of Betby
        Sportsbook Solution. Demo version is fully functional and allows you to
        create a simulation and explore a complete user experience.
        <p v-if="showContact">
          Please contact us for further detailed info and integration procedure:
        </p>
      </div>
      <CtaButton
        v-if="showContact"
        class="button"
        label="Send a Message"
        v-bind:onClick="onButtonClick"
      />
    </div>
  </HeaderPopup>
</template>

<script>
import HeaderPopup from "./HeaderPopup";
import CtaButton from "./CtaButton";

export default {
  name: "DemoBlock",
  components: {
    HeaderPopup,
    CtaButton
  },
  props: {
    onButtonClick: Function,
    onCloseClick: Function,
    showContact: Boolean
  }
};
</script>

<style scoped>
.demo-block {
  width: 240px;
  box-sizing: border-box;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  margin: 24px 0 13px;
  color: #4a4a4a;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.8;
}
.highlight {
  color: #0821ff;
}

  @media (max-width: 600px) {
    .demo-block {
      width: 100%;
    }
  }
</style>
